import { Route } from 'lucide-react';
import { RoutingDecisionEvent as RoutingDecisionEventType } from '../types';
import { Badge } from '@/components/ui/badge';
import EventShell from './EventShell';

interface Props {
  event: RoutingDecisionEventType;
}

export default function RoutingDecisionEvent({ event }: Props) {
  return (
    <EventShell
      color="cyan"
      icon={<Route className="w-3.5 h-3.5" />}
      title="Routing Decision"
      timestamp={event.created_at}
    >
      <p>
        Matched rule: <span className="font-medium text-foreground">{event.payload.rule_name}</span>
      </p>
      <div className="flex items-center gap-2 pt-0.5">
        <Badge variant="outline" className="text-[10px] h-4 px-1.5">
          {event.payload.rule_type}
        </Badge>
        <span>{event.payload.action_type}</span>
      </div>
    </EventShell>
  );
}
